import { render } from "./UiUpload.vue?vue&type=template&id=a5d7e7e0&ts=true"
import script from "./UiUpload.vue?vue&type=script&lang=ts"
export * from "./UiUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__